import { render } from "./CartResumenSideBar.vue?vue&type=template&id=526a19ca&scoped=true"
import script from "./CartResumenSideBar.vue?vue&type=script&setup=true&lang=js"
export * from "./CartResumenSideBar.vue?vue&type=script&setup=true&lang=js"

import "./CartResumenSideBar.vue?vue&type=style&index=0&id=526a19ca&scoped=true&lang=css"

import exportComponent from "/var/www/html/public/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-526a19ca"],['__file',"src/components/Cart/CartResumenSideBar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "526a19ca"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('526a19ca', __exports__)) {
    console.log('reload')
    api.reload('526a19ca', __exports__)
  }
  
  module.hot.accept("./CartResumenSideBar.vue?vue&type=template&id=526a19ca&scoped=true", () => {
    console.log('re-render')
    api.rerender('526a19ca', render)
  })

}


export default __exports__